import React from "react";

import { v4 as uuidv4 } from "uuid";

import type { JSX } from "react";

interface HeaderBlockProps {
  blockList: {
    title: string;
    value: string | number;
  }[];
}

function HeaderBlock({ blockList }: HeaderBlockProps): JSX.Element {
  return (
    <div className="border-input flex flex-row items-center justify-center gap-[0.78125rem] rounded-[0.46875rem] border p-[0.46875rem] whitespace-nowrap">
      {blockList.map((block) => (
        <div
          key={uuidv4()}
          className="border-l-border flex flex-row gap-[0.3125rem] border-l pl-[0.78125rem] first:border-l-0 first:pl-0"
        >
          <div className="px-[0.46875rem] font-semibold">{block.title}</div>
          <div className="bg-muted w-full rounded-[0.234375rem] px-[0.46875rem] text-center">
            {block.value}
          </div>
        </div>
      ))}
    </div>
  );
}

export default HeaderBlock;
